// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"83e66645","523":"a54d42f4","922":"3c717b50","968":"731fa7b4","989":"70c914b0"}[chunkId] + ".chunk.js";
};